module.exports = __webpack_public_path__ + "static/img/foot.c607a02a.png";